import { Route, Routes } from 'react-router-dom';
import Index from './features/index/Index';
import CustomerInformation from './components/customerInformation/CustomerInformation';
import ComplaintRegistration from './components/complaintRegistration/ComplaintRegistration';
import { ComplaintSummary } from './components/complaintSummary/ComplaintSummary';
import StatusCheck from './components/statusCheck/StatusCheck';
import { getComplaintPositionComponents } from './features/complaintPositionsComponents/ComplaintPositionsComponentsSlice';
import { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SuccessfulComplaint from './components/successfulComplaint/SuccessfulComplaint';
import { CompanyInformation } from './components/companyInformation/CompanyInformation';
import { CompanyComplaintRegistration } from './components/companyComplaintRegistration/CompanyComplaintRegistration';
import { CustomerTypePage } from './components/customerTypePage/CustomerTypePage';
import CompanyReceiptGoods from './components/companyReceiptGoods/CompanyReceiptGoods';
import { CompanyComplaintSummary } from './components/companyComplaintSummary/companyComplaintSummary';
import { StatusCheckView } from './components/statusCheck/StatusCheckView';
import { useNavigate } from 'react-router-dom';
import { clearAllPositions } from './features/complaintPosition/ComplaintPositionSlice';
import UnsuccessfulComplaint from './components/unsuccessfulComplaint/UnsuccessfulComplaint';
 
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  useEffect(() => {
    dispatch(getComplaintPositionComponents());
  }, [dispatch]);

  useEffect(() => {
    const handlePageLoadOrRefresh = () => {
      if (window.location.pathname !== '/') {
        window.location.replace('/');
      }
    };

    window.addEventListener('load', handlePageLoadOrRefresh);
    window.addEventListener('popstate', handlePageLoadOrRefresh);

    return () => {
      window.removeEventListener('load', handlePageLoadOrRefresh);
      window.removeEventListener('popstate', handlePageLoadOrRefresh);
    };
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/customers" element={<CustomerTypePage />} />
        <Route path="/information" element={<CustomerInformation />} />
        <Route path="/registration" element={<ComplaintRegistration />} />
        <Route path="/summary" element={<ComplaintSummary />} />
        <Route path="/status" element={<StatusCheck />} />
        <Route path="/send" element={<SuccessfulComplaint />} />
        <Route path="/unsend" element={<UnsuccessfulComplaint />} />
        {/* FIRMA */}
        <Route path="/companySearch" element={<CompanyInformation />} />
        <Route path="/companyRegistration" element={<CompanyComplaintRegistration />} />
        <Route path="/companyReceiptGoods" element={<CompanyReceiptGoods />} />
        <Route path="/companySummary" element={<CompanyComplaintSummary />} />
        <Route path="/statusCheck" element={<StatusCheckView />} />
      </Routes>
    </div>
  );
}

export default App;